import { useState } from "react";
import { Message, Modal, ModalContent } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { formatDateForDisplay } from '../../utils/formatDate';

export const AssetImages = ({ inspectionImages = [] }) => {
    const [selectedImage, setSelectedImage] = useState(null);

    return (
        <div>
            {inspectionImages.length > 0 && (
                <div style={{ fontSize: "1rem", color: "#555" }}>
                    <strong>Last Updated:</strong> {formatDateForDisplay(inspectionImages[0].uploadedAt)}
                </div>
            )}
            {inspectionImages.length === 0 && (
                <Message info>No inspection images available for this asset.</Message>
            )}
            <div style={{ padding: "1.5rem 2rem", display: "flex", flexWrap: "wrap", gap: "1rem", justifyContent: "center" }}>
                {inspectionImages.map((image) => (
                    <div key={image.id} style={{ border: "1px solid #ddd", borderRadius: "4px", overflow: "hidden", width: "220px", textAlign: "center" }}>
                        <img
                            src={image.imageUrl}
                            alt={`Inspection from ${image.uploadedAt}`}
                            onClick={() => setSelectedImage(image)}
                            style={{ objectFit: "cover", height: "160px", width: "100%", display: "block", cursor: "pointer" }}
                        />
                        <div style={{ padding: "0.5rem", fontSize: "0.85rem", color: "#666" }}>
                            <div>{formatDateForDisplay(image.uploadedAt)}</div>
                            <Link to={`/standdown/${image.inspectionId}`}>
                                Inspection #{image.inspectionId}
                            </Link>
                        </div>
                    </div>
                ))}
            </div>

            <Modal open={!!selectedImage} onClose={() => setSelectedImage(null)} closeIcon size="large">
                <ModalContent style={{ textAlign: "center", padding: "1rem" }}>
                    {selectedImage && (
                        <>
                            <img
                                src={selectedImage.imageUrl}
                                alt={`Inspection from ${formatDateForDisplay(selectedImage.uploadedAt)}`}
                                style={{ maxWidth: "100%", maxHeight: "80vh", borderRadius: "4px" }}
                            />
                            <div style={{ marginTop: "0.75rem", fontSize: "0.9rem", color: "#666" }}>
                                {formatDateForDisplay(selectedImage.uploadedAt)} &mdash;{" "}
                                <Link to={`/standdown/${selectedImage.inspectionId}`} onClick={() => setSelectedImage(null)}>
                                    Inspection #{selectedImage.inspectionId}
                                </Link>
                            </div>
                        </>
                    )}
                </ModalContent>
            </Modal>
        </div>
    );
};
